// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-list-content[data-v-0ae17561]{margin-top:8px;display:flex;width:100%;align-items:center}.input-list span[data-v-0ae17561]{width:70%;line-height:1.4}.input-list i[data-v-0ae17561]{cursor:pointer}.pop-title[data-v-0ae17561]{color:#b9b8b8}", ""]);
// Exports
module.exports = exports;
